import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren } from 'react';
import { mergeClasses } from '@/utils/style';
import { GlowingButton } from '../GlowingButton/GlowingButton';
import IconPlay from '@/assets/icons/heroIcons/Play.svg';
import { ButtonProps } from '../types';
export function PlayButton(t0) {
  const $ = _c(11);
  let children;
  let className;
  let other;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = other;
  } else {
    children = $[1];
    className = $[2];
    other = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = mergeClasses("flex items-center", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconPlay className="mr-2 text-white lg:h-8 lg:w-8" />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== other || $[9] !== t1) {
    t3 = <GlowingButton {...other} className={t1}>{t2}{children}</GlowingButton>;
    $[7] = children;
    $[8] = other;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}